import React from 'react';
import SimpleButton from '../components/atoms/SimpleButton';
import { connect } from 'react-redux';
import { hideTextOverlay } from '../actions/textoverlay';
import ReactTimeout from 'react-timeout';

 
class TextOverlay extends React.Component {
    componentDidUpdate(prevProps, prevState) {
      if(!prevProps.textoverlay.isActive && this.props.textoverlay.isActive) {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }
    }
    render () {
      const downloadlinks = this.props.textoverlay.download.split('|||');
      const downloadstr = this.props.textoverlay.downloadStr;
      const downloadlink2 = this.props.textoverlay.download2;
      const downloadstr2 = this.props.textoverlay.downloadStr2;

        return (
            <div id="textoverlay" className={`${this.props.textoverlay.isActive?"active":"inactive"}`}>
              <div className="overlayinner">
              <h4>{this.props.textoverlay.headline}</h4>
              <div>
                <p dangerouslySetInnerHTML={{__html:this.props.textoverlay.text}}></p>
                
                {
                  downloadlinks.length===1 &&
                  <p className="pdflink">
                    <a href={downloadlinks[0]} target="_blank">
                    {downloadstr}
                    </a>
                  </p>
                }
                {downloadlink2!=="" && (
                  <p className="pdflink">
                        <a href={downloadlink2} target="_blank">
                          {downloadstr2}
                        </a>
                      </p>
                      
                    )}
                {
                  downloadlinks.length===2 &&
                  <p className="pdflink">
                  <a href={downloadlinks[0]} target="_blank">» Laden Sie hier die Bedingungen (Laufzeit 3 Jahre) als PDF herunter.</a>
                  <br/>
                  <br/>
                  <a href={downloadlinks[1]} target="_blank">» Laden Sie hier die Bedingungen (Laufzeit 5 Jahre) als PDF herunter.</a>
                  </p>
                }

                
              </div>
              
              <SimpleButton children="Schliessen." onClick={(evt) => this.props.dispatch(hideTextOverlay())} />
              </div>
            </div>
        );
    }

}


const mapStateToProps = (state) => {
  return {
    textoverlay: state.textoverlay
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(TextOverlay));


// WEBPACK FOOTER //
// ./src/utils/TextOverlay.js